import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Card,
  Col,
  notification,
  Spin,
  Row,
  Select,
  Tabs,
  Button,
  Typography,
  Tooltip as AntdTooltip,
} from "antd";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import {
  MenuUnfoldOutlined,
  CaretRightFilled,
  BarsOutlined,
  FileExcelOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import config from "../../util/ApiforContext";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import Replace2x from "../../util/Extensions/ReplaceExtension";
import { Collapse } from "antd";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { odata } from "../Filters/Helper";
import RequestHandler from "../../util/RequestHandler";
import { func } from "prop-types";
import { useTranslation } from "react-i18next";
const { Panel } = Collapse;
const { Option } = Select;
const { Text } = Typography;
const expiration = localStorage.getItem("expiration");
const COLORS = [
  "#003668",
  "#0061ba",
  "#1f94ff",
  "#8dbbe5",
  "#8de5cd",
  "#00b684",
  "#006448",
];
const RADIAN = Math.PI / 180;
const renderCustomizedLabelTRY = ({ x, y, stroke, value }) => {
  return "% " + value.toFixed(2);
};
const CustomToolTip = (props) => {
  try {
    const { active, payload, label } = props;
    if (!active || !payload) {
      return null;
    }
    return (
      <div>
        <p>
          <strong>{label}</strong>
        </p>
        {payload.map((item, i) => (
          <p key={i}>
            <strong style={{ backgroundColor: "white", opacity: "0.6" }}>
              {item.name}
            </strong>
          </p>
        ))}
      </div>
    );
  } catch (error) {}
};
const BankList = () => {
  const { t } = useTranslation();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-device-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const isChartWidth = useMediaQuery({ query: "(min-width: 500px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const history = useHistory();
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" });
  const [bankListForTRY, setBankListForTRY] = useState([]);
  const [bigTotal, setBigTotal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currencyList, setCurrencyList] = useState([]);
  const [bankListForTotal, setBankListForTotal] = useState([]);
  const [exchangeRate, setExchangeRate] = useState([]);
  const [chartTakeValuesState, setChartTakeValuesState] = useState([]);
  const [totalBalanceWithCurrency, setTotalBalanceWithCurrency] = useState([]);
  const [totalChart, setTotalChart] = useState([]);
  const [titles, setTitles] = useState([]);
  const [termCurrencyList, setTermCurrencyList] = useState([]);
  const [termDepositAccounts, setTermDepositAccounts] = useState([]);
  const [activeKey, setActiveKey] = useState("9999");
  const [yesterday, setYesterday] = useState("");
  const [isLiveValue, setIsLiveValue] = useState(false);
  const [dailyDate, setDailyDate] = useState("");
  const [currencyLogo, setCurrencyLogo] = useState("₺");
  const [liveDate, setLiveDate] = useState("");
  const [query, setQuery] = useState("");
  const [termBalanceTotal, setTermBalanceTotal] = useState();
  const [balanceTotal, setBalanceTotal] = useState();
  const [
    alternativeAvailableBalanceTotal,
    setAlternativeAvailableBalanceTotal,
  ] = useState();
  const [totalCurrencyValue, setTotalCurrencyValue] = useState(0);
  const [isDigitBankBalance, setIsDigitBankBalance] = useState();
  const [useAvailableBalance, setUseAvailableBalance] = useState(false);
  const [useAvailableCreditBalance, setUseAvailableCreditBalance] =
    useState(false);
  const [isBuying, setIsBuying] = useState(false);
  const errorList = [];
  const token = localStorage.getItem("token");
  const errorListNotification = (type) => {
    errorList.map((item) => {
      notification[type]({
        message: t("error"),
        description: item,
        duration: 2,
      });
    });
  };
  const chartTakeValues = [];
  const chartTakeValuesTotal = [];

  useEffect(() => {
    const today = new Date();
    const yesterday = new Date(today);
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setIsDigitBankBalance(response.data.isDigitBankBalance);
        }
      }
    );

    yesterday.setDate(yesterday.getDate() - 1);
    today.toDateString();
    setYesterday(yesterday);
    yesterday.toDateString();
    if (expiration < Date.now()) {
      localStorage.removeItem("expiration");
      localStorage.removeItem("token");
      window.location.reload();
    }
    if (localStorage.getItem("token") == null) {
      window.location.reload();
    }
    axios
      .get(
        `${config.apiUrl}/tenantaccount/GetListForTotalChart?$apply=groupby((BankName),aggregate(Balance with sum as value))`,
        config.headers
      )
      .then((res) => {
        const chartList = [];
        const chartValuesTRY = res.data;
        {
          chartValuesTRY.map((value, index) => {
            var chartModel = {};
            chartModel.name = value.bankName;
            chartModel.value = value.value;
            chartList.push(chartModel);
          });
        }
        var total = 0;
        var valueTotal = 0;
        try {
          {
            chartList.map((value, index) => {
              if (value.value < 0) {
                value.value = 0;
              }
              total += value.value;
            });
          }

          {
            chartList.map((value, index) => {
              var percents = ((value.value / total) * 100).toFixed(2);
              var percentsFloat = parseFloat(percents);
              if (percentsFloat < 0) {
                percentsFloat = 0;
              }
              value.value = percentsFloat;
              if (value.value < 10) {
                valueTotal += value.value;
              } else {
                chartTakeValues.push(value);
              }
            });
          }
          if (valueTotal != 0) {
            var model = {};
            model.name = "DİĞER";
            model.value = valueTotal;
            chartTakeValues.push(model);
          }
          setTotalChart(chartTakeValues);
        } catch (error) {
          if (error.response.status === 403 || error.response.status === 401) {
            history.push("/not-authorized-access");
          } else if (error.response.status === 406) {
            error.response.data.data.map((item) => {
              errorList.push(item);
            });
            errorListNotification("error");
          }
        }
      });
    axios
      .get(
        `${config.apiUrl}/tenantaccount?$filter=currencyId ne null&$apply=groupby((Currency,CurrencyId))&$orderby=currencyId`,
        config.headers
      )
      .then((res) => {
        axios
          .get(
            `${config.apiUrl}/TenantAccount/CurrencyBankListTotal?$filter=CurrencyId ne null`,
            config.headers
          )
          .then((res) => {
            setTotalBalanceWithCurrency(res.data);
          })
          .catch((error) => {
            if (error.response.status === 406) {
              error.response.data.data.map((item) => {
                errorList.push(item);
              });
              errorListNotification("error");
            } else if (
              error.response.status === 403 ||
              error.response.status === 401
            ) {
              history.push("/not-authorized-access");
            } else {
              openNotificationWithIconWarningExcel("error");
            }
          });
        if (res.data.length !== 0) {
          axios
            .get(
              `${
                config.apiUrl
              }/tenantaccount/GetTenantAccountsList?currencyId=${
                res.data[0]?.currencyId ?? 0
              }&$apply=groupby((bankName,bankId,bankLogo,currency,currencyLogo),aggregate(Balance with sum as balance, TermBalance with sum as termBalance, AlternativeAvailableBalance with sum as alternativeAvailableBalance))`,
              config.headers
            )
            .then((res) => {
              var bankAccountList = [];
              var toplam = 0;
              var currency = "";
              var currencyLogo = "";
              var termBalanceTotal = 0;
              var balanceTotal = 0;
              var alternativeAvailableBalanceTotal = 0;
              res.data.map((item) => {
                var model = {};
                model.bankLogo = item.bankLogo;
                model.bankId = item.bankId;
                model.balance = item.balance.toFixed(2).replace(".", ",");
                model.termBalance = item.termBalance
                  .toFixed(2)
                  .replace(".", ",");
                model.alternativeAvailableBalance =
                  item.alternativeAvailableBalance.toFixed(2).replace(".", ",");
                termBalanceTotal += item.termBalance;
                balanceTotal += item.balance;
                alternativeAvailableBalanceTotal +=
                  item.alternativeAvailableBalance;
                model.currency = item.currency;
                model.currencyLogo = item.currencyLogo;
                model.type = item.type;
                bankAccountList.push(model);
                toplam += item.balance;
                currency = item.currency;
                currencyLogo = item.currencyLogo;
              });
              var model = {};
              model.bankLogo = "Toplam";
              model.balance = toplam.toFixed(2).replace(".", ",");
              model.bankId = "";
              model.currency = currency;
              model.currencyLogo = currencyLogo;
              bankAccountList.push(model);
              setBalanceTotal(balanceTotal);
              setTermBalanceTotal(termBalanceTotal);
              setBigTotal(model.balance);
              setBankListForTRY(bankAccountList);
              setAlternativeAvailableBalanceTotal(
                alternativeAvailableBalanceTotal
              );
            })
            .catch((error) => {
              if (
                error.response.status === 403 ||
                error.response.status === 401
              ) {
                history.push("/not-authorized-access");
              } else if (error.response.status === 406) {
                error.response.data.data.map((item) => {
                  errorList.push(item);
                });
                errorListNotification("error");
              }
            });
        } else {
          return null;
        }
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          history.push("/not-authorized-access");
        }
      });
    axios
      .get(
        `${config.apiUrl}/tenantaccount/GetListForTotal?useAvailableBalance=${useAvailableBalance}&useAvailableCreditBalance=${useAvailableCreditBalance}`,
        config.headers
      )
      .then((res) => {
        var tenantTotalList = [];
        var total = 0;
        res.data.map((item) => {
          var model = {};
          model.bankLogo = item.bankLogo;
          model.totalBalance = item.balance;
          model.totalBalance += item.termBalance;
          model.bankName = item.bankName;
          model.currency = item.tenantList;
          tenantTotalList.push(model);
          model.totalBalance = parseFloat(model.totalBalance.toFixed(2));
          total += model.totalBalance;
        });
        var model = {};
        model.bankLogo = "TOPLAM";
        model.balance = parseFloat(total.toFixed(2));
        tenantTotalList.push(model);
        setTotalCurrencyValue(parseFloat(total.toFixed(2)));
        setBankListForTotal(tenantTotalList);
      });
    axios
      .get(
        `${config.apiUrl}/TenantCurrency/GetExchangeRateList`,
        config.headers
      )
      .then((res) => {
        axios
          .get(
            `${config.apiUrl}/TenantCurrency/GetIsDailyValue`,
            config.headers
          )
          .then((ress) => {
            setIsLiveValue(ress.data.isLiveValue);
          })
          .catch((error) => {
            if (
              error.response.status === 403 ||
              error.response.status === 401
            ) {
              history.push("/not-authorized-access");
            } else if (error.response.status === 406) {
              error.response.data.data.map((item) => {
                errorList.push(item);
              });
              errorListNotification("error");
            }
          });
        axios
          .get(
            `${config.apiUrl}/TenantCurrency/GetIsBuyingValue`,
            config.headers
          )
          .then((res) => {
            setIsBuying(res.data === true);
          })
          .catch((error) => {
            if (
              error.response.status === 403 ||
              error.response.status === 401
            ) {
              history.push("/not-authorized-access");
            } else if (error.response.status === 406) {
              error.response.data.data.map((item) => {
                errorList.push(item);
              });
              errorListNotification("error");
            }
          });
        setLiveDate(res.data[0].liveDate);
        setDailyDate(res.data[0].dailyDate);
        setExchangeRate(res.data);
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          history.push("/not-authorized-access");
        } else if (error.response.status === 406) {
          error.response.data.data.map((item) => {
            errorList.push(item);
          });
          errorListNotification("error");
        }
      });
    axios
      .get(
        `${config.apiUrl}/TenantCurrency/GetCurrencyListWithIsCalculated?$filter=CurrencyId ne null&$apply=groupby((Currency,CurrencyId))&$orderby=CurrencyId`,
        config.headers
      )
      .then((res) => {
        axios
          .get(
            `${config.apiUrl}/tenantaccount/GetCurrencyListWithTermBalanceWithIsCalculated`,
            config.headers
          )
          .then((resp) => {
            var title = [];
            var termCurrencyId = [];
            title.push(t("bank"));
            res.data.map((item) => {
              title.push(item.currency);
            });
            resp.data
              .sort((a, b) => a.currencyId - b.currencyId)
              .map((item) => {
                if (!title.includes(t("termDeposit") + " " + item.currency)) {
                  title.push(t("termDeposit") + " " + item.currency);
                }
                termCurrencyId.push(item.currencyId);
              });

            setTitles(title);
            setTermCurrencyList(termCurrencyId);
            setTermDepositAccounts(resp.data);
          });
        setCurrencyList(res.data);
        setActiveKey("9999");
        if (res.data.length !== 0) {
          axios
            .get(
              `${
                config.apiUrl
              }/tenantaccount/GetTenantAccountChartList?currencyId=${
                res[0]?.currencyId ?? 0
              }&$apply=groupby((name),aggregate(value with sum as value))`,
              config.headers
            )
            .then((res) => {
              const chartValuesTRY = res.data;
              var total = 0;
              var valueTotal = 0;
              var currency = "";
              try {
                {
                  chartValuesTRY.map((value, index) => {
                    if (value.value < 0) {
                      value.value = 0;
                    }
                    total += value.value;
                  });
                }

                {
                  chartValuesTRY.map((value, index) => {
                    var percents = ((value.value / total) * 100).toFixed(2);
                    var percentsFloat = parseFloat(percents);

                    if (percentsFloat < 0) {
                      percentsFloat = 0;
                    }
                    value.value = percentsFloat;

                    if (value.value < 10) {
                      valueTotal += value.value;
                    } else {
                      currency = value.currency;
                      chartTakeValuesTotal.push(value);
                    }
                  });
                }
                if (valueTotal != 0) {
                  var model = {};
                  model.Currency = res.data[0]?.currency;
                  model.name = "DİĞER";
                  model.value = valueTotal;
                  chartTakeValuesTotal.push(model);
                }
                setChartTakeValuesState(chartTakeValuesTotal);
                setLoading(false);
              } catch (error) {
                if (
                  error.response.status === 403 ||
                  error.response.status === 401
                ) {
                  history.push("/not-authorized-access");
                } else if (error.response.status === 406) {
                  error.response.data.data.map((item) => {
                    errorList.push(item);
                  });
                  errorListNotification("error");
                }
              }
            })
            .catch((error) => {
              if (
                error.response.status === 403 ||
                error.response.status === 401
              ) {
                history.push("/not-authorized-access");
              } else if (error.response.status === 406) {
                error.response.data.data.map((item) => {
                  errorList.push(item);
                });
                errorListNotification("error");
              }
            });
        } else {
          return null;
        }
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          history.push("/not-authorized-access");
        }
      });
  }, [
    setCurrencyList,
    setBankListForTRY,
    setBankListForTotal,
    useAvailableBalance,
    useAvailableCreditBalance,
  ]);

  useEffect(() => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        if (response.isHasTransactionNotification) {
          const intervalId = setInterval(() => {
            RequestHandler.get(`/AccountTransaction/NotificationControl`).then(
              (res) => {
                if (res) accountTransactionNotification();
              }
            );
          }, 5 * 60 * 1000); // 5 dakika = 5 * 60 * 1000 ms
          return () => clearInterval(intervalId);
        }
      }
    });
  }, []);

  const accountTransactionNotification = () => {
    notification.close("finekra3");
    notification.info({
      message: t("updatedBankBalancesExist"),
      style: { height: 160 },
      description: (
        <div>
          <div>{t("clickToSeeUpdatedBankBalances")}</div>
          <Button
            style={{ marginTop: 5, position: "absolute", right: 20 }}
            type="primary"
            onClick={() => {
              notification.close("finekra3");
              window.location.reload();
            }}
          >
            <EyeOutlined /> {t("view")}
          </Button>
        </div>
      ),
      duration: 0,
      key: "finekra3",
    });
  };

  useEffect(() => {
    axios
      .get(
        `${config.apiUrl}/tenantaccount?$filter=currencyId ne null&$apply=groupby((Currency,CurrencyId))&$orderby=currencyId`,
        config.headers
      )
      .then((res) => {
        axios
          .get(
            `${config.apiUrl}/TenantAccount/CurrencyBankListTotal?$filter=CurrencyId ne null`,
            config.headers
          )
          .then((res) => {
            setTotalBalanceWithCurrency(res.data);
          })
          .catch((error) => {
            if (error.response.status === 406) {
              error.response.data.data.map((item) => {
                errorList.push(item);
              });
              errorListNotification("error");
            } else if (
              error.response.status === 403 ||
              error.response.status === 401
            ) {
              history.push("/not-authorized-access");
            } else {
              openNotificationWithIconWarningExcel("error");
            }
          });
        if (res.data.length !== 0) {
          axios
            .get(
              `${
                config.apiUrl
              }/tenantaccount/GetTenantAccountsList?currencyId=${
                res.data[0]?.currencyId ?? 0
              }${query}&$apply=groupby((bankName,bankId,bankLogo,currency,currencyLogo),aggregate(Balance with sum as balances, TermBalance with sum as termBalance, AlternativeAvailableBalance with sum as alternativeAvailableBalance))`,
              config.headers
            )
            .then((res) => {
              var bankAccountList = [];
              var toplam = 0;
              var currency = "";
              var currencyLogo = "";
              var termBalanceTotal = 0;
              var balanceTotal = 0;
              var alternativeAvailableBalanceTotal = 0;
              res.data.map((item) => {
                var model = {};
                model.bankLogo = item.bankLogo;
                model.bankId = item.bankId;
                model.balance = item.balances.toFixed(2).replace(".", ",");
                model.termBalance = item.termBalance
                  .toFixed(2)
                  .replace(".", ",");
                model.alternativeAvailableBalance =
                  item.alternativeAvailableBalance.toFixed(2).replace(".", ",");
                termBalanceTotal += item.termBalance;
                balanceTotal += item.balance;
                alternativeAvailableBalanceTotal +=
                  item.alternativeAvailableBalance;
                model.currency = item.currency;
                model.currencyLogo = item.currencyLogo;
                model.type = item.type;
                bankAccountList.push(model);
                toplam += item.balances;
                currency = item.currency;
                currencyLogo = item.currencyLogo;
              });
              var model = {};
              model.bankLogo = "Toplam";
              model.balance = toplam.toFixed(2).replace(".", ",");
              model.bankId = "";
              model.currency = currency;
              model.currencyLogo = currencyLogo;
              bankAccountList.push(model);
              setBalanceTotal(balanceTotal);
              setTermBalanceTotal(termBalanceTotal);
              setBankListForTRY(bankAccountList);
              setBigTotal(model.balance);
              setAlternativeAvailableBalanceTotal(
                alternativeAvailableBalanceTotal
              );
            })
            .catch((error) => {
              if (
                error.response.status === 403 ||
                error.response.status === 401
              ) {
                history.push("/not-authorized-access");
              } else if (error.response.status === 406) {
                error.response.data.data.map((item) => {
                  errorList.push(item);
                });
                errorListNotification("error");
              }
            });
        } else {
          return null;
        }
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          history.push("/not-authorized-access");
        }
      });
  }, [query]);

  // const titles = [];
  //  bankListForTotal.map((item)=>{
  //    item.currency.filter(x=> currencyList.includes(x.currencyId === 3 && x.termBalance !== null)[0]?.currencyId  //1,2,3
  //  })

  function onChange(value) {
    var exchangeValue = exchangeRate.filter((x) => x.currencyCode == value)[0]
      ?.value;
    if (value != "TRY") {
      bankListForTotal.map((item) => {
        item.totalBalance = (
          item.totalBalance / parseFloat(exchangeValue.replace(",", "."))
        ).toFixed(2);
      });
    }
    axios
      .get(
        `${config.apiUrl}/tenantaccount/GetListForTotal?currencyCode=${value}&useAvailableBalance=${useAvailableBalance}&useAvailableCreditBalance=${useAvailableCreditBalance}`,
        config.headers
      )
      .then((res) => {
        var tenantTotalList = [];
        var total = 0;
        res.data.map((item) => {
          setCurrencyLogo(item.currencyLogo);
          var model = {};

          model.bankLogo = item.bankLogo;
          model.currencyLogo = item.currencyLogo;
          model.totalBalance = parseFloat(item.balance.toFixed(2));
          model.totalBalance += parseFloat(item.termBalance.toFixed(2));
          model.bankName = item.bankName;
          model.currency = item.tenantList;
          model.totalBalance = parseFloat(model.totalBalance.toFixed(2));
          tenantTotalList.push(model);
          total += model.totalBalance;
        });
        var model = {};
        model.bankLogo = "TOPLAM";
        model.balance = parseFloat(total.toFixed(2));
        tenantTotalList.push(model);
        setTotalCurrencyValue(parseFloat(total.toFixed(2)));
        setBankListForTotal(tenantTotalList);
      });
    // setBankListForTotal(bankListForTotal)
  }

  function onSearch(val) {}
  const columnsTotal = [
    {
      title: t("bank"),
      dataIndex: "bankLogo",
      width: "20%",
      render: (text, row, index) => {
        {
          if (row.bankLogo != "TOPLAM") {
            return <img src={row.bankLogo}></img>;
          }
        }
      },
    },
    {
      title: t("balance"),
      dataIndex: "balance",
      align: "right",
      render: (text, row, index) => {
        {
          if (row.bankLogo != "TOPLAM") {
            return (
              <CurrencyFormat
                value={row.totalBalance}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"₺"}
              />
            );
          }
        }
      },
    },
  ];
  const columnsExchangeRate = [
    {
      dataIndex: "currencyName",
    },
    {
      dataIndex: "currencyCode",
    },
    {
      title: isBuying ? t("exchangeRateBuying") : t("exchangeRateSelling"),
      dataIndex: "value",
      align: "right",
      render: (val) => {
        if (val == null) return "-";
        const n =
          typeof val === "string" ? Number(val.replace(",", ".")) : Number(val);
        if (!Number.isFinite(n) || +n.toFixed(2) === 0) return "-";
        return n.toLocaleString("tr-TR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
  ];
  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setQuery(order);
  };
  const columns = [
    {
      title: t("bank"),
      dataIndex: "bankLogo",
      render: (text, row, index) => {
        return (
          <div style={{ width: 100 }}>
            <img src={row.bankLogo}></img>
          </div>
        );
      },
    },
    {
      title: t("demandDepositBalance"),
      dataIndex: "balance",
      align: "right",
      key: "balances",
      render: (text, row, index) => {
        return isDigitBankBalance ? (
          <CurrencyFormat
            value={row.balance}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            prefix={row.currencyLogo}
          />
        ) : (
          <CurrencyFormat
            value={row.balance.split(",")[0]}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            prefix={row.currencyLogo}
          />
        );
      },
    },
    {
      title: t("termDepositBalance"),
      dataIndex: "termBalance",
      align: "right",
      key: "termBalance",
      render: (text, row, index) => {
        return isDigitBankBalance ? (
          <CurrencyFormat
            value={row.termBalance}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            prefix={row.currencyLogo}
          />
        ) : (
          <CurrencyFormat
            value={row.termBalance.split(",")[0]}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            prefix={row.currencyLogo}
          />
        );
      },
    },
    {
      title: t("totalBalance"),
      dataIndex: "",
      align: "right",
      key: "totalBalance",
      render: (text, row, index) => {
        return parseFloat(
          (
            parseFloat(row.termBalance.replace(",", ".")) +
            parseFloat(row.balance.replace(",", "."))
          ).toFixed(2)
        )
          .toString()
          .includes(".") === true ? (
          <CurrencyFormat
            value={
              isDigitBankBalance
                ? parseFloat(
                    (
                      parseFloat(row.termBalance.replace(",", ".")) +
                      parseFloat(row.balance.replace(",", "."))
                    ).toFixed(2)
                  )
                : parseFloat(
                    (
                      parseFloat(row.termBalance.replace(",", ".")) +
                      parseFloat(row.balance.replace(",", "."))
                    )
                      .toFixed(2)
                      .toString()
                      .split(".")[0]
                  )
            }
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            prefix={row.currencyLogo}
          />
        ) : (
          <>
            <CurrencyFormat
              value={
                isDigitBankBalance
                  ? parseFloat(
                      (
                        parseFloat(row.termBalance.replace(",", ".")) +
                        parseFloat(row.balance.replace(",", "."))
                      ).toFixed(2)
                    )
                  : parseFloat(
                      (
                        parseFloat(row.termBalance.replace(",", ".")) +
                        parseFloat(row.balance.replace(",", "."))
                      )
                        .toFixed(2)
                        .toString()
                        .split(".")[0]
                    )
              }
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={row.currencyLogo}
            />
            {isDigitBankBalance ? ",00" : ""}
          </>
        );
      },
    },
    {
      title: t("availableBalance"),
      dataIndex: "alternativeAvailableBalance",
      align: "right",
      key: "alternativeAvailableBalance",
      render: (text, row, index) => {
        return isDigitBankBalance ? (
          <CurrencyFormat
            value={row.alternativeAvailableBalance}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            prefix={row.currencyLogo}
          />
        ) : (
          <CurrencyFormat
            value={row.alternativeAvailableBalance.split(",")[0]}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            prefix={row.currencyLogo}
          />
        );
      },
    },
    {
      title: t("details"),
      dataIndex: "BankId",
      width: "20%",
      render: (row, record, text) => {
        if (record.bankLogo === "Toplam") {
          return null;
        } else {
          return (
            <Link
              style={{ fontSize: "150%" }}
              to={`/bank-list-accounts/${record.bankId}-${record.currency}`}
            >
              <MenuUnfoldOutlined />
            </Link>
          );
        }
      },
    },
  ];
  const ContactSideBar = (value, e) => {
    var totalCurrencyValue = 0;
    var currency = "";
    bankListForTRY
      .filter((x) => x.bankLogo == "Toplam")
      .map((item) => {
        if (item.bankLogo === "Toplam") {
          totalCurrencyValue = item.balance;
          currency = item.currencyLogo;
        }
      });
    return (
      <Row>
        {isTabletOrMobile === false && (
          <>
            <Col span={12} style={{ paddingLeft: 19 }}>
              <Table
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                columns={columns}
                size="small"
                dataSource={bankListForTRY.filter(
                  (x) => x.currency == value && x.bankLogo != "Toplam"
                )}
                rowKey="Id"
                sortable={true}
                onChange={paging}
                bordered
                title={() => t("bankList")}
                summary={(pageData) => {
                  return (
                    <>
                      <Table.Summary.Row style={{ textAlign: "end" }}>
                        <Table.Summary.Cell>
                          <strong>{t("total")}:</strong>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <Text>
                            {balanceTotal.toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <Text>
                            {termBalanceTotal.toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <Text>
                            {parseFloat(
                              bigTotal.replace(",", ".")
                            ).toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <Text>
                            {alternativeAvailableBalanceTotal.toLocaleString(
                              "tr-TR",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <Text></Text>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            </Col>
            <Col span={12}>
              <PieChart width={500} height={500}>
                <Pie
                  outerRadius={150}
                  data={chartTakeValuesState}
                  fill="#8884d8"
                  label={renderCustomizedLabelTRY}
                >
                  {chartTakeValuesState.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip content={CustomToolTip} />
              </PieChart>
              {chartTakeValuesState.map((entry, index) => (
                <div key={`cell-${index}`}>
                  <a style={{ color: COLORS[index % COLORS.length] }}>
                    <CaretRightFilled />
                  </a>
                  {entry.name}
                </div>
              ))}
            </Col>
          </>
        )}
        {isTabletOrMobile && (
          <>
            <Col span={24}>
              <Table
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                columns={columns}
                size="small"
                dataSource={bankListForTRY.filter(
                  (x) => x.currency == value && x.bankLogo != "Toplam"
                )}
                rowKey="Id"
                sortable={true}
                onChange={paging}
                bordered
                title={() => t("bankList")}
                footer={() => (
                  <div>
                    <div>
                      {t("total")}:{" "}
                      <CurrencyFormat
                        value={
                          isDigitBankBalance
                            ? totalCurrencyValue
                            : totalCurrencyValue.split(",")[0]
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={currency}
                      />
                    </div>
                  </div>
                )}
              />
            </Col>
            <Col span={24}>
              <PieChart
                width={isChartWidth === true ? 500 : 300}
                height={isChartWidth === true ? 500 : 300}
              >
                <Pie
                  outerRadius={isChartWidth === true ? 150 : 80}
                  data={chartTakeValuesState}
                  fill="#8884d8"
                  label={renderCustomizedLabelTRY}
                >
                  {chartTakeValuesState.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip content={CustomToolTip} />
              </PieChart>
              {chartTakeValuesState.map((entry, index) => (
                <div key={`cell-${index}`}>
                  <a style={{ color: COLORS[index % COLORS.length] }}>
                    <CaretRightFilled />
                  </a>
                  {entry.name}
                </div>
              ))}
            </Col>
          </>
        )}
      </Row>
    );
  };
  const openNotificationWithIconExcel = (type) => {
    notification[type]({
      message: t("notificationSuccessTitle"),
      description: t("notificationSuccessExcelDownloadDescription"),
      duration: 2,
    });
  };
  const openNotificationWithIconWarningExcel = (type) => {
    notification[type]({
      message: t("error"),
      description: t("excelDownloadError"),
      duration: 2,
    });
  };

  const handleChange = (activeKey) => {
    axios
      .get(
        `${config.apiUrl}/tenantaccount/GetTenantAccountsList?currencyId=${
          activeKey == "null" ? 0 : activeKey
        }${query}&$apply=groupby((bankName,bankId,bankLogo,currency,currencyLogo),aggregate(Balance with sum as balance, TermBalance with sum as termBalance, AlternativeAvailableBalance with sum as alternativeAvailableBalance))`,
        config.headers
      )
      .then((res) => {
        var bankAccountList = [];
        var toplam = 0;
        var currency = "";
        var currencyLogo = "";
        var termBalanceTotal = 0;
        var balanceTotal = 0;
        var alternativeAvailableBalanceTotal = 0;
        res.data.map((item) => {
          var model = {};
          model.bankLogo = item.bankLogo;
          model.bankId = item.bankId;
          model.balance = item.balance.toFixed(2).replace(".", ",");
          model.termBalance = item.termBalance.toFixed(2).replace(".", ",");
          model.alternativeAvailableBalance = item.alternativeAvailableBalance
            .toFixed(2)
            .replace(".", ",");
          model.currency = item.currency;
          model.currencyLogo = item.currencyLogo;
          model.type = item.type;
          bankAccountList.push(model);
          toplam += item.balance;
          toplam += item.termBalance;
          termBalanceTotal += item.termBalance;
          balanceTotal += item.balance;
          alternativeAvailableBalanceTotal += item.alternativeAvailableBalance;
          currency = item.currency;
          currencyLogo = item.currencyLogo;
        });
        var model = {};
        model.bankLogo = "Toplam";
        model.balance = toplam.toFixed(2).replace(".", ",");
        model.bankId = "";
        model.currency = currency;
        model.currencyLogo = currencyLogo;
        bankAccountList.push(model);
        setBalanceTotal(balanceTotal);
        setTermBalanceTotal(termBalanceTotal);
        setBankListForTRY(bankAccountList);
        setBigTotal(model.balance);
        setAlternativeAvailableBalanceTotal(alternativeAvailableBalanceTotal);
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          history.push("/not-authorized-access");
        } else if (error.response.status === 406) {
          error.response.data.data.map((item) => {
            errorList.push(item);
          });
          errorListNotification("error");
        }
      });

    axios
      .get(
        `${config.apiUrl}/tenantaccount/GetTenantAccountChartList?currencyId=${
          activeKey == "null" ? 0 : activeKey
        }&$apply=groupby((name),aggregate(value with sum as value))`,
        config.headers
      )
      .then((res) => {
        const chartValuesTRY = res.data;
        var total = 0;
        var valueTotal = 0;
        var currency = "";
        try {
          {
            chartValuesTRY.map((value, index) => {
              if (value.value < 0) {
                value.value = 0;
              }
              total += value.value;
            });
          }

          {
            chartValuesTRY.map((value, index) => {
              var percents = ((value.value / total) * 100).toFixed(2);
              var percentsFloat = parseFloat(percents);

              if (percentsFloat < 0) {
                percentsFloat = 0;
              }
              value.value = percentsFloat;

              if (value.value < 10) {
                valueTotal += value.value;
              } else {
                currency = value.Currency;
                chartTakeValuesTotal.push(value);
              }
            });
          }
          if (valueTotal != 0) {
            var model = {};
            model.name = "DİĞER";
            model.value = valueTotal;
            chartTakeValuesTotal.push(model);
          }
          setChartTakeValuesState(chartTakeValuesTotal);
        } catch (error) {
          if (error.response.status === 403 || error.response.status === 401) {
            history.push("/not-authorized-access");
          } else if (error.response.status === 406) {
            error.response.data.data.map((item) => {
              errorList.push(item);
            });
            errorListNotification("error");
          }
        }
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          history.push("/not-authorized-access");
        } else if (error.response.status === 406) {
          error.response.data.data.map((item) => {
            errorList.push(item);
          });
          errorListNotification("error");
        }
      });
    setActiveKey(activeKey);
  };

  const { TabPane } = Tabs;
  var totalValue = 0;
  var currency = "";
  bankListForTotal.map((item) => {
    if (item.bankLogo === "TOPLAM") {
      totalValue = item.balance;
      currency = "₺";
    }
  });

  function onChangeBalanceDropDown(value) {
    if (value === "Kullanılabilir Bakiye") {
      setUseAvailableBalance(true);
      setUseAvailableCreditBalance(false);
    } else if (value === "Kredili Kullanılabilir Bakiye") {
      setUseAvailableBalance(false);
      setUseAvailableCreditBalance(true);
    } else {
      setUseAvailableBalance(false);
      setUseAvailableCreditBalance(false);
    }
  }

  return (
    <div>
      {isTabletOrMobileDevice ? (
        <Row>
          <Col span={8}>
            <p style={{ fontSize: "100%" }}>
              <BarsOutlined /> {t("bankList")}
            </p>
          </Col>
          <Col span={12}>
            <Select
              optionFilterProp="children"
              onChange={onChangeBalanceDropDown}
              size="small"
              style={{ width: "100%" }}
              defaultValue={"Bakiye"}
            >
              <Option key={0} value={"Bakiye"}>
                {t("balance")}
              </Option>
              <Option key={1} value={"Kullanılabilir Bakiye"}>
                {t("availableBalance")}
              </Option>
              <Option key={2} value={"Kredili Kullanılabilir Bakiye"}>
                {t("availableCreditBalance")}
              </Option>
            </Select>
          </Col>
          <Col span={1}>
            {activeKey === "9999" ? (
              <div style={{ marginTop: -5, display: "flex" }}>
                <AntdTooltip
                  title={t("balanceCalculationInfo")}
                  className="gx-text-blue"
                  style={{ marginRight: 10, marginTop: 6, fontSize: "150%" }}
                >
                  <QuestionCircleOutlined />
                </AntdTooltip>
                <ReactHTMLTableToExcel
                  table="emp"
                  filename="BankaListesi"
                  sheet="tablexlsx"
                  buttonText={
                    <p
                      style={{
                        fontSize: "200%",
                        color: "green",
                        marginBottom: "-6px",
                        marginTop: "-5px",
                        marginLeft: "-11px",
                        marginRight: "-12px",
                        background: "white",
                      }}
                    >
                      <FileExcelOutlined />
                    </p>
                  }
                />
              </div>
            ) : null}
          </Col>
        </Row>
      ) : (
        <Row>
          <Col span={16}>
            <p style={{ fontSize: "120%" }}>
              <BarsOutlined /> {t("bankList")}
            </p>
          </Col>
          <Col span={2} style={{ textAlign: "right" }}>
            <AntdTooltip
              title={t("noteForAvailableBalance")}
              className="gx-text-blue"
              style={{ marginRight: 10, marginTop: 6, fontSize: "150%" }}
            >
              <QuestionCircleOutlined />
            </AntdTooltip>
          </Col>
          <Col span={4}>
            <Select
              optionFilterProp="children"
              onChange={onChangeBalanceDropDown}
              size="middle"
              style={{ width: "100%" }}
              defaultValue={"Bakiye"}
            >
              <Option key={0} value={"Bakiye"}>
                {t("balance")}
              </Option>
              <Option key={1} value={"Kullanılabilir Bakiye"}>
                {t("availableBalance")}
              </Option>
              <Option key={2} value={"Kredili Kullanılabilir Bakiye"}>
                {t("availableCreditBalance")}
              </Option>
            </Select>
          </Col>
          <Col span={2}>
            {activeKey === "9999" ? (
              <div>
                <ReactHTMLTableToExcel
                  table="emp"
                  filename="BankaListesi"
                  sheet="tablexlsx"
                  buttonText={
                    <p
                      style={{
                        fontSize: "200%",
                        color: "green",
                        marginBottom: "-6px",
                        marginTop: "-5px",
                        marginLeft: "-11px",
                        marginRight: "-12px",
                        background: "white",
                      }}
                    >
                      <FileExcelOutlined />
                    </p>
                  }
                />
              </div>
            ) : null}
          </Col>
        </Row>
      )}

      <Tabs onChange={handleChange} activeKey={activeKey}>
        {currencyList.length !== 0 ? (
          <TabPane tab={t("all")} key="9999">
            <Spin spinning={loading}>
              <Row justify={"center"}>
                {isTabletOrMobile === false && (
                  <>
                    <Col span={24}>
                      <table class="table" style={{ marginBottom: 50 }}>
                        <tr>
                          {/* BAŞLIKLAR */}
                          {titles.map((item) => {
                            return (
                              <th
                                style={{ paddingBottom: 10, textAlign: "end" }}
                              >
                                {item}
                              </th>
                            );
                          })}
                          <td style={{ paddingLeft: 30 }}>
                            <Select
                              showSearch
                              optionFilterProp="children"
                              onChange={onChange}
                              size="small"
                              style={{ marginBottom: 4 }}
                              onSearch={onSearch}
                              defaultValue={"TRY"}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {currencyList.map((item) => {
                                return (
                                  <Option value={item.currency}>
                                    {" "}
                                    <strong>
                                      {item.currency} {t("total")}{" "}
                                    </strong>
                                  </Option>
                                );
                              })}
                            </Select>
                          </td>
                        </tr>
                        {bankListForTotal.map((item) => {
                          // KOLON DETAYLAR
                          if (item.bankLogo !== "TOPLAM") {
                            var currency = item.currency;
                            return (
                              <tr>
                                <td
                                  style={{
                                    paddingBottom: 13,
                                    textAlign: "end",
                                  }}
                                >
                                  <img
                                    style={{ width: 100, marginRight: 15 }}
                                    src={item.bankLogo}
                                  />
                                </td>
                                {/* TÜM PARA BİRİMLERİ İÇİN BAKİYE KOLONLARI (VADESİZ) */}
                                {currencyList.map((curr) => {
                                  const account = currency?.find(
                                    (acc) => acc.currencyId === curr.currencyId && acc.type !== "Vadeli"
                                  );
                                  return (
                                    <td
                                      style={{
                                        paddingBottom: 13,
                                        width: 120,
                                        textAlign: "end",
                                      }}
                                      class="text-center"
                                    >
                                      {account ? (
                                        account.balance
                                          .toString()
                                          .includes(".") ? (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={
                                                isDigitBankBalance
                                                  ? account.balance
                                                  : account.balance
                                                      .toString()
                                                      .split(".")[0]
                                              }
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={account.currencyLogo}
                                            />
                                          </div>
                                        ) : (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={
                                                isDigitBankBalance
                                                  ? account.balance
                                                  : account.balance
                                                      .toString()
                                                      .split(".")[0]
                                              }
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={account.currencyLogo}
                                            />
                                            {isDigitBankBalance ? ",00" : ""}
                                          </div>
                                        )
                                      ) : (
                                        <div style={{ whiteSpace: "nowrap" }}>
                                          <CurrencyFormat
                                            value={0}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            prefix={curr.currency === "TRY" ? "₺" : curr.currency === "USD" ? "$" : curr.currency === "EUR" ? "€" : ""}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                          />
                                        </div>
                                      )}
                                    </td>
                                  );
                                })}
                                {/* TÜM VADELİ PARA BİRİMLERİ İÇİN KOLONLAR */}
                                {currencyList.map((curr) => {
                                  if (termCurrencyList.includes(curr.currencyId)) {
                                    const termBalanceValue = termDepositAccounts
                                      .filter(acc => acc.bankName === item.bankName && acc.currencyId === curr.currencyId)
                                      .reduce((sum, acc) => sum + parseFloat(acc.balance || 0), 0);
                                    const currencyLogo = termDepositAccounts.find(acc => acc.currencyId === curr.currencyId)?.currencyLogo ||
                                      (curr.currency === "TRY" ? "₺" : curr.currency === "USD" ? "$" : curr.currency === "EUR" ? "€" : "");
                                    return (
                                      <td
                                        style={{
                                          paddingBottom: 13,
                                          width: 120,
                                          textAlign: "end",
                                        }}
                                        class="text-center"
                                      >
                                        {termBalanceValue > 0 ? (
                                          termBalanceValue.toString().includes(".") ? (
                                            <div style={{ whiteSpace: "nowrap" }}>
                                              <CurrencyFormat
                                                value={
                                                  isDigitBankBalance
                                                    ? termBalanceValue
                                                    : Math.floor(termBalanceValue)
                                                }
                                                displayType={"text"}
                                                decimalSeparator={","}
                                                thousandSeparator={"."}
                                                prefix={currencyLogo}
                                              />
                                            </div>
                                          ) : (
                                            <div style={{ whiteSpace: "nowrap" }}>
                                              <CurrencyFormat
                                                value={
                                                  isDigitBankBalance
                                                    ? termBalanceValue
                                                    : Math.floor(termBalanceValue)
                                                }
                                                displayType={"text"}
                                                decimalSeparator={","}
                                                thousandSeparator={"."}
                                                prefix={currencyLogo}
                                              />
                                              {isDigitBankBalance ? ",00" : ""}
                                            </div>
                                          )
                                        ) : (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={0}
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={currencyLogo}
                                              fixedDecimalScale={true}
                                              decimalScale={2}
                                            />
                                          </div>
                                        )}
                                      </td>
                                    );
                                  }
                                  return null;
                                })}

                                <td
                                  style={{
                                    paddingBottom: 13,
                                    textAlign: "end",
                                  }}
                                >
                                  {/* SAĞ KOLON TOPLAMLAR */}
                                  {item.totalBalance
                                    .toString()
                                    .includes(".") ? (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? item.totalBalance
                                            : item.totalBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={item.currencyLogo ?? "₺"}
                                      />
                                    </div>
                                  ) : (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? item.totalBalance
                                            : item.totalBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={item.currencyLogo ?? "₺"}
                                      />
                                      {isDigitBankBalance ? ",00" : ""}{" "}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        })}
                        <tr>
                          <td class="text-center">
                            <strong>{t("total")}</strong>
                          </td>
                          {totalBalanceWithCurrency.map((accounts) => {
                            return (
                              <td style={{ textAlign: "end" }}>
                                {/* DÖVİZ KURLARI ALT TOPLAM */}
                                {accounts.balance.toString().includes(".") ? (
                                  <div style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <CurrencyFormat
                                      value={
                                        isDigitBankBalance
                                          ? accounts.balance
                                          : accounts.balance
                                              .toString()
                                              .split(".")[0]
                                      }
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={accounts.currencyLogo}
                                    />
                                  </div>
                                ) : (
                                  <div style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <CurrencyFormat
                                      value={
                                        isDigitBankBalance
                                          ? accounts.balance
                                          : accounts.balance
                                              .toString()
                                              .split(".")[0]
                                      }
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={accounts.currencyLogo}
                                    />
                                    {isDigitBankBalance ? ",00" : ""}{" "}
                                  </div>
                                )}
                              </td>
                            );
                          })}
                          {totalBalanceWithCurrency.map((accounts) => {
                            if (
                              termCurrencyList.includes(accounts.currencyId)
                            ) {
                              return (
                                <td style={{ textAlign: "end" }}>
                                  {/* DÖVİZ KURLARI ALT TOPLAM */}
                                  {accounts.tempBalance
                                    .toString()
                                    .includes(".") ? (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? accounts.tempBalance
                                            : accounts.tempBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={accounts.currencyLogo}
                                      />
                                    </div>
                                  ) : (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? accounts.tempBalance
                                            : accounts.tempBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={accounts.currencyLogo}
                                      />
                                      {isDigitBankBalance ? ",00" : ""}{" "}
                                    </div>
                                  )}
                                </td>
                              );
                            }
                          })}

                          <td style={{ textAlign: "end" }}>
                            {/* SAĞ ALT TOPLAM */}

                            {totalCurrencyValue.toString().includes(".") ? (
                              <div style={{ whiteSpace: "nowrap" }}>
                                <CurrencyFormat
                                  value={
                                    isDigitBankBalance
                                      ? totalCurrencyValue
                                      : totalCurrencyValue
                                          .toString()
                                          .split(".")[0]
                                  }
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={currencyLogo}
                                />
                              </div>
                            ) : (
                              <div style={{ whiteSpace: "nowrap" }}>
                                <CurrencyFormat
                                  value={
                                    isDigitBankBalance
                                      ? totalCurrencyValue
                                      : totalCurrencyValue
                                          .toString()
                                          .split(".")[0]
                                  }
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={currencyLogo}
                                />
                                {isDigitBankBalance ? ",00" : ""}{" "}
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr></tr>
                      </table>

                      <table
                        hidden
                        id="emp"
                        class="table"
                        style={{ marginBottom: 50 }}
                      >
                        <tr>
                          {/* BAŞLIKLAR */}
                          {titles.map((item) => {
                            return (
                              <th style={{ paddingBottom: 10 }}>{item}</th>
                            );
                          })}
                          <td>
                            <Select
                              showSearch
                              optionFilterProp="children"
                              onChange={onChange}
                              size="small"
                              style={{ marginBottom: 4 }}
                              onSearch={onSearch}
                              defaultValue={"TRY"}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {currencyList.map((item) => {
                                return (
                                  <Option value={item.currency}>
                                    {" "}
                                    <strong>
                                      {item.currency} {t("total")}{" "}
                                    </strong>
                                  </Option>
                                );
                              })}
                            </Select>
                          </td>
                        </tr>
                        {bankListForTotal.map((item) => {
                          // KOLON DETAYLAR
                          if (item.bankLogo !== "TOPLAM") {
                            var currency = item.currency;
                            return (
                              <tr>
                                <td style={{ paddingBottom: 13 }}>
                                  {item.bankName}
                                </td>
                                {/* TÜM PARA BİRİMLERİ İÇİN BAKİYE KOLONLARI (VADESİZ) */}
                                {currencyList.map((curr) => {
                                  const account = currency?.find(
                                    (acc) => acc.currencyId === curr.currencyId && acc.type !== "Vadeli"
                                  );
                                  return (
                                    <td
                                      style={{ paddingBottom: 13, width: 120 }}
                                      class="text-center"
                                    >
                                      {account ? (
                                        account.balance
                                          .toString()
                                          .includes(".") ? (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={
                                                isDigitBankBalance
                                                  ? account.balance
                                                  : account.balance
                                                      .toString()
                                                      .split(".")[0]
                                              }
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={account.currencyLogo}
                                            />
                                          </div>
                                        ) : (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={
                                                isDigitBankBalance
                                                  ? account.balance
                                                  : account.balance
                                                      .toString()
                                                      .split(".")[0]
                                              }
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={account.currencyLogo}
                                            />
                                            {isDigitBankBalance ? ",00" : ""}
                                          </div>
                                        )
                                      ) : (
                                        <div style={{ whiteSpace: "nowrap" }}>
                                          <CurrencyFormat
                                            value={0}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            prefix={curr.currency === "TRY" ? "₺" : curr.currency === "USD" ? "$" : curr.currency === "EUR" ? "€" : ""}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                          />
                                        </div>
                                      )}
                                    </td>
                                  );
                                })}
                                {/* TÜM VADELİ PARA BİRİMLERİ İÇİN KOLONLAR */}
                                {currencyList.map((curr) => {
                                  if (termCurrencyList.includes(curr.currencyId)) {
                                    const account = currency?.find(
                                      (acc) => acc.currencyId === curr.currencyId
                                    );
                                    return (
                                      <td
                                        style={{
                                          paddingBottom: 13,
                                          width: 120,
                                        }}
                                        class="text-center"
                                      >
                                        {account ? (
                                          account.termBalance
                                            .toString()
                                            .includes(".") ? (
                                            <div
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <CurrencyFormat
                                                value={
                                                  isDigitBankBalance
                                                    ? account.termBalance
                                                    : account.termBalance
                                                        .toString()
                                                        .split(".")[0]
                                                }
                                                displayType={"text"}
                                                decimalSeparator={","}
                                                thousandSeparator={"."}
                                                prefix={account.currencyLogo}
                                              />
                                            </div>
                                          ) : (
                                            <div
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <CurrencyFormat
                                                value={
                                                  isDigitBankBalance
                                                    ? account.termBalance
                                                    : account.termBalance
                                                        .toString()
                                                        .split(".")[0]
                                                }
                                                displayType={"text"}
                                                decimalSeparator={","}
                                                thousandSeparator={"."}
                                                prefix={account.currencyLogo}
                                              />
                                              {isDigitBankBalance ? ",00" : ""}
                                            </div>
                                          )
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    );
                                  }
                                  return null;
                                })}

                                <td
                                  style={{
                                    paddingBottom: 13,
                                    textAlign: "center",
                                  }}
                                >
                                  {/* SAĞ KOLON TOPLAMLAR */}
                                  {item.totalBalance
                                    .toString()
                                    .includes(".") ? (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? item.totalBalance
                                            : item.totalBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={item.currencyLogo ?? "₺"}
                                      />
                                    </div>
                                  ) : (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? item.totalBalance
                                            : item.totalBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={item.currencyLogo ?? "₺"}
                                      />
                                      {isDigitBankBalance ? ",00" : ""}{" "}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        })}
                        <tr>
                          <td class="text-center">
                            <strong>{t("total")}</strong>
                          </td>
                          {totalBalanceWithCurrency.map((accounts) => {
                            return (
                              <td>
                                {/* DÖVİZ KURLARI ALT TOPLAM */}
                                {accounts.balance.toString().includes(".") ? (
                                  <div style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <CurrencyFormat
                                      value={
                                        isDigitBankBalance
                                          ? accounts.balance
                                          : accounts.balance
                                              .toString()
                                              .split(".")[0]
                                      }
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={accounts.currencyLogo}
                                    />
                                  </div>
                                ) : (
                                  <div style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <CurrencyFormat
                                      value={
                                        isDigitBankBalance
                                          ? accounts.balance
                                          : accounts.balance
                                              .toString()
                                              .split(".")[0]
                                      }
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={accounts.currencyLogo}
                                    />
                                    {isDigitBankBalance ? ",00" : ""}{" "}
                                  </div>
                                )}
                              </td>
                            );
                          })}
                          {totalBalanceWithCurrency.map((accounts) => {
                            if (
                              termCurrencyList.includes(accounts.currencyId)
                            ) {
                              return (
                                <td>
                                  {/* DÖVİZ KURLARI ALT TOPLAM */}
                                  {accounts.tempBalance
                                    .toString()
                                    .includes(".") ? (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? accounts.tempBalance
                                            : accounts.tempBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={accounts.currencyLogo}
                                      />
                                    </div>
                                  ) : (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? accounts.tempBalance
                                            : accounts.tempBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={accounts.currencyLogo}
                                      />
                                      {isDigitBankBalance ? ",00" : ""}{" "}
                                    </div>
                                  )}
                                </td>
                              );
                            }
                          })}

                          <td style={{ textAlign: "center" }}>
                            {/* SAĞ ALT TOPLAM */}

                            {totalCurrencyValue.toString().includes(".") ? (
                              <div style={{ whiteSpace: "nowrap" }}>
                                <CurrencyFormat
                                  value={
                                    isDigitBankBalance
                                      ? totalCurrencyValue
                                      : totalCurrencyValue
                                          .toString()
                                          .split(".")[0]
                                  }
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={currencyLogo}
                                />
                              </div>
                            ) : (
                              <div style={{ whiteSpace: "nowrap" }}>
                                <CurrencyFormat
                                  value={
                                    isDigitBankBalance
                                      ? totalCurrencyValue
                                      : totalCurrencyValue
                                          .toString()
                                          .split(".")[0]
                                  }
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={currencyLogo}
                                />
                                {isDigitBankBalance ? ",00" : ""}{" "}
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr></tr>
                      </table>
                    </Col>
                    <Col span={12} style={{ marginBottom: 50, marginTop: 40 }}>
                      <Collapse>
                        <Panel header={t("clickToViewExchangeRates")} key="1">
                          <Card
                            title={t("exchangeRatesInfo")}
                            style={{ marginLeft: "1%" }}
                            extra={`${t(
                              isLiveValue ? t("Live") : t("Daily")
                            )} • ${isBuying ? t("Buying") : t("Selling")} - ${t(
                              "exchangeRatesInfo"
                            )} ${isLiveValue ? liveDate : dailyDate}`}
                            className={`gx-card-widget`}
                          >
                            <div className="gx-table-responsive">
                              <Table
                                className="gx-table-no-bordered"
                                columns={columnsExchangeRate}
                                dataSource={exchangeRate}
                                pagination={false}
                                bordered={false}
                                size="small"
                              />
                            </div>
                          </Card>
                        </Panel>
                      </Collapse>
                    </Col>
                    <Col span={12}>
                      <PieChart width={500} height={500}>
                        <Pie
                          outerRadius={150}
                          data={totalChart}
                          fill="#8884d8"
                          label={renderCustomizedLabelTRY}
                        >
                          {totalChart.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip content={CustomToolTip} />
                      </PieChart>
                      {totalChart.map((entry, index) => (
                        <div key={`cell-${index}`}>
                          <a style={{ color: COLORS[index % COLORS.length] }}>
                            <CaretRightFilled />
                          </a>
                          {entry.name}
                        </div>
                      ))}
                    </Col>
                  </>
                )}
                {isTabletOrMobile && (
                  <>
                    <Col span={24} style={{ overflowX: "auto" }}>
                      <table
                        style={{
                          marginBottom: 50,
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <tr>
                          {titles.map((item) => {
                            return <th>{item}</th>;
                          })}
                          <td>
                            <Select
                              showSearch
                              optionFilterProp="children"
                              onChange={onChange}
                              onSearch={onSearch}
                              defaultValue={"TRY"}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {currencyList.map((item) => {
                                return (
                                  <Option value={item.currency}>
                                    {" "}
                                    <strong>
                                      {item.currency} {t("total")}{" "}
                                    </strong>
                                  </Option>
                                );
                              })}
                            </Select>
                          </td>
                        </tr>
                        {bankListForTotal.map((item) => {
                          if (item.bankLogo !== "TOPLAM") {
                            var currency = item.currency;
                            return (
                              <tr>
                                <td>
                                  <img
                                    style={{ width: 120 }}
                                    src={item.bankLogo}
                                  />
                                </td>
                                {/* TÜM PARA BİRİMLERİ İÇİN BAKİYE KOLONLARI (VADESİZ) */}
                                {currencyList.map((curr) => {
                                  const account = currency?.find(
                                    (acc) => acc.currencyId === curr.currencyId && acc.type !== "Vadeli"
                                  );
                                  return (
                                    <td
                                      style={{
                                        paddingBottom: 13,
                                        width: 120,
                                        textAlign: "end",
                                      }}
                                      class="text-center"
                                    >
                                      {account ? (
                                        account.balance
                                          .toString()
                                          .includes(".") ? (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={
                                                isDigitBankBalance
                                                  ? account.balance
                                                  : account.balance
                                                      .toString()
                                                      .split(".")[0]
                                              }
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={account.currencyLogo}
                                            />
                                          </div>
                                        ) : (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={
                                                isDigitBankBalance
                                                  ? account.balance
                                                  : account.balance
                                                      .toString()
                                                      .split(".")[0]
                                              }
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={account.currencyLogo}
                                            />
                                            {isDigitBankBalance ? ",00" : ""}
                                          </div>
                                        )
                                      ) : (
                                        <div style={{ whiteSpace: "nowrap" }}>
                                          <CurrencyFormat
                                            value={0}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            prefix={curr.currency === "TRY" ? "₺" : curr.currency === "USD" ? "$" : curr.currency === "EUR" ? "€" : ""}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                          />
                                        </div>
                                      )}
                                    </td>
                                  );
                                })}
                                {/* TÜM VADELİ PARA BİRİMLERİ İÇİN KOLONLAR */}
                                {currencyList.map((curr) => {
                                  if (termCurrencyList.includes(curr.currencyId)) {
                                    const termBalanceValue = termDepositAccounts
                                      .filter(acc => acc.bankName === item.bankName && acc.currencyId === curr.currencyId)
                                      .reduce((sum, acc) => sum + parseFloat(acc.balance || 0), 0);
                                    const currencyLogo = termDepositAccounts.find(acc => acc.currencyId === curr.currencyId)?.currencyLogo ||
                                      (curr.currency === "TRY" ? "₺" : curr.currency === "USD" ? "$" : curr.currency === "EUR" ? "€" : "");
                                    return (
                                      <td
                                        style={{
                                          paddingBottom: 13,
                                          width: 120,
                                          textAlign: "end",
                                        }}
                                        class="text-center"
                                      >
                                        {termBalanceValue > 0 ? (
                                          termBalanceValue.toString().includes(".") ? (
                                            <div style={{ whiteSpace: "nowrap" }}>
                                              <CurrencyFormat
                                                value={
                                                  isDigitBankBalance
                                                    ? termBalanceValue
                                                    : Math.floor(termBalanceValue)
                                                }
                                                displayType={"text"}
                                                decimalSeparator={","}
                                                thousandSeparator={"."}
                                                prefix={currencyLogo}
                                              />
                                            </div>
                                          ) : (
                                            <div style={{ whiteSpace: "nowrap" }}>
                                              <CurrencyFormat
                                                value={
                                                  isDigitBankBalance
                                                    ? termBalanceValue
                                                    : Math.floor(termBalanceValue)
                                                }
                                                displayType={"text"}
                                                decimalSeparator={","}
                                                thousandSeparator={"."}
                                                prefix={currencyLogo}
                                              />
                                              {isDigitBankBalance ? ",00" : ""}
                                            </div>
                                          )
                                        ) : (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <CurrencyFormat
                                              value={0}
                                              displayType={"text"}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                              prefix={currencyLogo}
                                              fixedDecimalScale={true}
                                              decimalScale={2}
                                            />
                                          </div>
                                        )}
                                      </td>
                                    );
                                  }
                                  return null;
                                })}

                                <td
                                  style={{
                                    paddingBottom: 13,
                                    textAlign: "end",
                                  }}
                                >
                                  {/* SAĞ KOLON TOPLAMLAR */}
                                  {item.totalBalance
                                    .toString()
                                    .includes(".") ? (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? item.totalBalance
                                            : item.totalBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={item.currencyLogo ?? "₺"}
                                      />
                                    </div>
                                  ) : (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? item.totalBalance
                                            : item.totalBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={item.currencyLogo ?? "₺"}
                                      />
                                      {isDigitBankBalance ? ",00" : ""}{" "}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        })}
                        <tr>
                          <td class="text-center">
                            <strong>{t("total")}</strong>
                          </td>
                          {totalBalanceWithCurrency.map((accounts) => {
                            return (
                              <td style={{ textAlign: "end" }}>
                                {/* DÖVİZ KURLARI ALT TOPLAM */}
                                {accounts.balance.toString().includes(".") ? (
                                  <div style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <CurrencyFormat
                                      value={
                                        isDigitBankBalance
                                          ? accounts.balance
                                          : accounts.balance
                                              .toString()
                                              .split(".")[0]
                                      }
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={accounts.currencyLogo}
                                    />
                                  </div>
                                ) : (
                                  <div style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <CurrencyFormat
                                      value={
                                        isDigitBankBalance
                                          ? accounts.balance
                                          : accounts.balance
                                              .toString()
                                              .split(".")[0]
                                      }
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={accounts.currencyLogo}
                                    />
                                    {isDigitBankBalance ? ",00" : ""}{" "}
                                  </div>
                                )}
                              </td>
                            );
                          })}
                          {totalBalanceWithCurrency.map((accounts) => {
                            if (
                              termCurrencyList.includes(accounts.currencyId)
                            ) {
                              return (
                                <td style={{ textAlign: "end" }}>
                                  {/* DÖVİZ KURLARI ALT TOPLAM */}
                                  {accounts.tempBalance
                                    .toString()
                                    .includes(".") ? (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? accounts.tempBalance
                                            : accounts.tempBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={accounts.currencyLogo}
                                      />
                                    </div>
                                  ) : (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      <CurrencyFormat
                                        value={
                                          isDigitBankBalance
                                            ? accounts.tempBalance
                                            : accounts.tempBalance
                                                .toString()
                                                .split(".")[0]
                                        }
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        thousandSeparator={"."}
                                        prefix={accounts.currencyLogo}
                                      />
                                      {isDigitBankBalance ? ",00" : ""}{" "}
                                    </div>
                                  )}
                                </td>
                              );
                            }
                          })}

                          <td style={{ textAlign: "end" }}>
                            {/* SAĞ ALT TOPLAM */}

                            {totalCurrencyValue.toString().includes(".") ? (
                              <div style={{ whiteSpace: "nowrap" }}>
                                <CurrencyFormat
                                  value={
                                    isDigitBankBalance
                                      ? totalCurrencyValue
                                      : totalCurrencyValue
                                          .toString()
                                          .split(".")[0]
                                  }
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={currencyLogo}
                                />
                              </div>
                            ) : (
                              <div style={{ whiteSpace: "nowrap" }}>
                                <CurrencyFormat
                                  value={
                                    isDigitBankBalance
                                      ? totalCurrencyValue
                                      : totalCurrencyValue
                                          .toString()
                                          .split(".")[0]
                                  }
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={currencyLogo}
                                />
                                {isDigitBankBalance ? ",00" : ""}{" "}
                              </div>
                            )}
                          </td>
                        </tr>
                      </table>
                    </Col>
                    <Col span={24}>
                      <Collapse>
                        <Panel header={t("clickToViewExchangeRates")} key="1">
                          <Card
                            title={t("exchangeRatesInfo")}
                            style={{ marginLeft: "1%" }}
                            extra={`${isLiveValue ? t("Live") : t("Daily")} • ${
                              isBuying ? t("Buying") : t("Selling")
                            } - ${t("exchangeRatesInfo")} ${
                              isLiveValue ? liveDate : dailyDate
                            }`}
                            className={`gx-card-widget`}
                          >
                            <div className="gx-table-responsive">
                              <Table
                                className="gx-table-no-bordered"
                                columns={columnsExchangeRate}
                                dataSource={exchangeRate}
                                pagination={false}
                                bordered={false}
                                size="small"
                              />
                            </div>
                          </Card>
                        </Panel>
                      </Collapse>
                    </Col>
                    <Col span={24}>
                      <PieChart
                        width={isChartWidth === true ? 500 : 300}
                        height={isChartWidth === true ? 500 : 300}
                      >
                        <Pie
                          outerRadius={isChartWidth === true ? 150 : 80}
                          data={totalChart}
                          fill="#8884d8"
                          label={renderCustomizedLabelTRY}
                        >
                          {totalChart.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip content={CustomToolTip} />
                      </PieChart>
                      {totalChart.map((entry, index) => (
                        <div key={`cell-${index}`}>
                          <a style={{ color: COLORS[index % COLORS.length] }}>
                            <CaretRightFilled />
                          </a>
                          {entry.name}
                        </div>
                      ))}
                    </Col>
                  </>
                )}
              </Row>
            </Spin>
          </TabPane>
        ) : (
          <Table
            style={{ marginLeft: "50%" }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
          />
        )}
        {currencyList.length === 0 ? (
          <TabPane tab={<span></span>} key="1">
            <Row>
              <Col span={24}>
                <Table
                  locale={{
                    emptyText: (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="Veri Yok"
                      />
                    ),
                  }}
                />
              </Col>
            </Row>
          </TabPane>
        ) : (
          currencyList.map((item, index) => {
            return (
              <>
                <TabPane
                  tab={<span>{item.currency}</span>}
                  key={item.currencyId}
                >
                  <Spin spinning={loading}>
                    {ContactSideBar(item.currency)}
                  </Spin>
                </TabPane>
              </>
            );
          })
        )}
      </Tabs>
    </div>
  );
};
export default BankList;
